import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const rootElement = document.getElementById("root")!;

// Remove SSR fallback after React loads
const staticHero = rootElement.querySelector('.static-hero');
if (staticHero) {
  staticHero.remove();
}

createRoot(rootElement).render(<App />);
